import { render, staticRenderFns } from "./SymptomaticAttestation.vue?vue&type=template&id=22598d6d&"
import script from "./SymptomaticAttestation.vue?vue&type=script&lang=ts&"
export * from "./SymptomaticAttestation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports